export const COOKIE_PREFERENCE_CATEGORY_IDS = [
  'strictly_necessary',
  'analytics',
  'functionality',
  'marketing',
] as const;

export type CookiePreferenceCategoryId =
  (typeof COOKIE_PREFERENCE_CATEGORY_IDS)[number];

export type CookiePreferenceCategoryCopy = {
  title: string;
  description: string;
};

export const COOKIE_PREFERENCE_CATEGORY_COPY: Record<
  CookiePreferenceCategoryId,
  CookiePreferenceCategoryCopy
> = {
  strictly_necessary: {
    title: 'STRICTLY NECESSARY',
    description:
      'THESE COOKIES ARE ESSENTIAL FOR THE WEBSITE TO WORK AND CANNOT BE SWITCHED OFF.',
  },
  analytics: {
    title: 'ANALYTICS',
    description:
      'THESE COOKIES HELP US MEASURE AND IMPROVE SITE PERFORMANCE BY TRACKING HOW YOU USE IT.',
  },
  functionality: {
    title: 'FUNCTIONALITY',
    description:
      'THESE COOKIES ALLOW THE WEBSITE TO REMEMBER YOUR CHOICES AND PROVIDE ENHANCED FEATURES.',
  },
  marketing: {
    title: 'MARKETING',
    description:
      'THESE COOKIES TRACK YOUR ONLINE ACTIVITY TO HELP ADVERTISERS DELIVER MORE RELEVANT ADS.',
  },
};

/**
 * Shown only when the pending save would turn marketing off having previously had it on.
 * Withdrawing marketing consent reloads the page, because third-party marketing scripts
 * cannot be unloaded in place — so the refresh is disclosed rather than dropped. Granting
 * consent never reloads, which is why this is conditional.
 */
export const COOKIE_PREFERENCE_RELOAD_NOTICE =
  'SAVING WILL REFRESH THE PAGE SO ANY TRACKING ALREADY LOADED IS REMOVED.';
